import {RefundableAmountVo} from '../../common/shared/api/billing/vo/RefundableAmountVo.interface';
import {RefundableAmount} from '../generated/types';

export function createRefundableAmount({
  total_remain_amount,
  not_refundable_amount,
  used_child_credit_amount,
  refundable_amount,
  refund_fee,
  final_refundable_amount,
}: RefundableAmountVo): RefundableAmount {
  return {
    finalRefundableAmount: final_refundable_amount,
    notRefundableAmount: not_refundable_amount,
    refundFee: refund_fee,
    refundableAmount: refundable_amount,
    totalRemainAmount: total_remain_amount,
    usedEventCash: used_child_credit_amount,
  };
}
